import colors from 'vuetify/lib/util/colors'

let magic = {
  name: 'Magic',
  dark: true,

  needFollow: true,
  needSub: false,

  bgRotate: 280,
  bgInvert: false,

  colors:{
    'overlay' : '#0f0e22',

    'background': '#00242F',
    'on-background': '#c1ffef',
    
    'surface': '#00212b',
    'on-surface': '#c1ffef',

    'primary': '#2bbc9a',
    'accent': '#00C8E1',
    'secondary': '#3f3a59',
    'error': '#FF5252',
    'info': '#2196F3',
    'success': '#4CAF50',
    'warning': '#FFC107',

    'bubble': '#002462',
    'on-bubble': '#FFFFFF',

    'twitch': '#9244FF',
  }
}

export default magic